import { render, staticRenderFns } from "./settings-organization-endpoint-unavailable-auto-response.vue?vue&type=template&id=71bb30cb&scoped=true&"
import script from "./settings-organization-endpoint-unavailable-auto-response.vue?vue&type=script&lang=js&"
export * from "./settings-organization-endpoint-unavailable-auto-response.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb30cb",
  null
  
)

export default component.exports